import React from 'react'

import './TableHeader.scss'

const TableHeader = () => {
  return (
    <div className='TableHeader'>
      <div className='TableHeader-headers'>
        <div className='TableHeader-aliadaName'>Aliada</div>
        <div className='TableHeader-date'>Fecha</div>
        <div className='TableHeader-serviceHours'>Duración</div>
        <div className='TableHeader-servicePrice'>Costo</div>
      </div>
    </div>
  )
}

TableHeader.displayName = 'TableHeader'

export default TableHeader



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/components/RecurrenceCard/components/TableHeader/TableHeader.js